import React from "react";
import { Link } from "react-router-dom";
function MenuItem({ image, name, price }) {
  return (
    <div className="menuItem">
      <div style={{ backgroundImage: `url(${image})` }}  > </div>
      <Link to="/Contact" style={{textDecoration:"none"}}> <h1> {name} </h1> </Link>
      <p> Starting at Rs {price}/- </p>

    </div>
  );
}

export default MenuItem;
